import { enUS as coreEN, nlNL as coreNL } from "@mui/material/locale"
import { enUS as gridEN, nlNL as gridNL } from "@mui/x-data-grid/locales"

// De standaardteksten van MUI (laden, geen opties, sluiten, paginering, datagrid) per taal van de
// app. Papiaments heeft geen MUI-locale; daar Nederlands, de andere officiële taal op de eilanden.
export const MUI_LOCALES = {
  en: [coreEN, gridEN],
  nl: [coreNL, gridNL],
  pa: [coreNL, gridNL]
}
